import { css } from 'styled-components';

export const alignmentCss = css`
  text-align: ${(p) => p.textAlign};
`;
